import React from 'react';
import 'react-h5-audio-player/lib/styles.css';
import SGCommonPage from '../../../components/SGCommonPage';


function SalokKabeer() {
    return (
        <div>
            <SGCommonPage title="Salok Kabeer ji" apiName="salok-kabeer-ji" audioName="salok_kabeer_ji" tlPage="20" /> 
        </div>
    )
}

export default SalokKabeer